import $ from 'jquery';

export default class AssetGroup {

    constructor() {

        if ($("#asset-group").length == 0) {
            return
        }


        Vue.component('asset-group', () => import('../components/AssetGroup.vue'));

        this.vm = new Vue({
            el: "#asset-group",
//            data: this.dataObject,
            methods: {


            }
        });


    }




}
